// src/services/listingService.js
import { createListing, uploadListingImages } from './api';

export const createListingHandler = async ({
  form,
  images,
  user,
  showLcdaField,
  categoryType,
  setSubmitting,
  setErrors,
  setImageUploadProgress,
  onSuccess,
  resetForm,
  setImages
}) => {
  try {
    setSubmitting(true);
    setErrors({});
    setImageUploadProgress(0);

    const finalCategoryId = form.subcategory_id || form.category_id;
    
    const listingData = {
      title: form.title?.trim() || '',
      description: form.description?.trim() || '',
      price: parseFloat(form.price) || 0,
      condition: form.condition || 'new',
      listing_type: form.listing_type || 'product',
      category_id: parseInt(finalCategoryId) || 0,
      state_id: parseInt(form.state_id) || 0,
      lga_id: parseInt(form.lga_id) || 0,
      seller_id: user?.user_id || 0,
      is_negotiable: Boolean(form.is_negotiable),
    };

    // Include LCDA if it exists and is selected
    if (showLcdaField && form.lcda_id) {
      listingData.lcda_id = parseInt(form.lcda_id);
    }

    // Collect ALL specialized data (everything except common fields)
    const commonFields = [
      'title', 'description', 'price', 'condition', 'listing_type',
      'category_id', 'subcategory_id', 'state_id', 'lga_id', 'lcda_id',
      'seller_id', 'is_negotiable', 'images'
    ];

    const specializedData = {};
    
    // Loop through all form fields
    Object.keys(form).forEach(key => {
      // Skip common fields
      if (commonFields.includes(key)) return;
      
      const value = form[key];
      
      // Only include if value is not empty (allow false booleans and 0 numbers)
      if (value !== '' && value !== null && value !== undefined) {
        // Convert booleans to strings if needed
        if (typeof value === 'boolean') {
          specializedData[key] = value.toString();
        } else {
          specializedData[key] = value;
        }
      }
    });

    // console.log('📊 Specialized data collected:', specializedData);
    
    // Only add specialized_data if we have any specialized fields
    if (Object.keys(specializedData).length > 0) {
      listingData.specialized_data = {
        type: categoryType,
        data: specializedData
      };
    }

    // console.log('📝 Final payload to backend:', listingData);
    
    // Create the listing
    const listingResponse = await createListing(listingData);
    
    const listingId = listingResponse.listing_id || listingResponse.data?.listing_id;

    if (!listingId) {
      throw new Error('No listing ID returned from server');
    }

    // Upload images
    if (images.length > 0) {
      try {
        setImageUploadProgress(0.1);
        
        const imageFiles = images.map(img => img.file || img.uri);
        
        const uploadResult = await uploadListingImages(listingId, imageFiles, (progress) => {
          if (typeof progress === 'number') {
            setImageUploadProgress(progress);
          } else {
            const currentProgress = 0.1 + (0.7 * (progress.loaded / progress.total || 0));
            setImageUploadProgress(currentProgress);
          }
        });
        
        // console.log('✅ Images uploaded successfully:', uploadResult);
      } catch (imageError) {
        // console.error('⚠️ Image upload failed:', imageError);
      }
    }

    setImageUploadProgress(1);
    
    // Success handling
    resetForm();
    setImages([]);
    
    setTimeout(() => {
      setImageUploadProgress(0);
      onSuccess(listingId);
    }, 500);
    
  } catch (err) {
    // console.error('❌ Listing creation failed:', err);
    const errorMessage = err.response?.data?.message || err.message || 'Unknown error occurred';
    setErrors({ general: `Failed to create listing: ${errorMessage}` });
    setImageUploadProgress(0);
  } finally {
    setSubmitting(false);
  }
};